import { Hash } from 'lucide-react';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { initials } from '../inboxUtils';

const AVATAR_PALETTES = [
  'bg-emerald-100 text-emerald-700',
  'bg-orange-100 text-orange-700',
  'bg-sky-100 text-sky-700',
  'bg-pink-100 text-pink-700',
  'bg-violet-100 text-violet-700',
  'bg-amber-100 text-amber-700',
  'bg-teal-100 text-teal-700',
  'bg-rose-100 text-rose-700',
] as const;

const hashKey = (value: string): number => {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
  }
  return hash;
};

type Props = {
  name?: string | null;
  phone?: string | null;
  className?: string;
};

/** Initials from the WhatsApp profile name: the webhook carries no profile picture. Decorative, the name is always next to it. */
export const ContactAvatar: FC<Props> = ({ name, phone, className }) => {
  const letters = initials(name);
  const palette = AVATAR_PALETTES[hashKey(name?.trim() || phone || '') % AVATAR_PALETTES.length];

  return (
    <span
      aria-hidden
      className={twMerge('flex size-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold', palette, className)}
    >
      {letters || <Hash className='size-5' />}
    </span>
  );
};
